import React from "react";
import Layouts from "./layout/Layout";
import { Route, Routes } from "react-router-dom";
import RegisterMain from "./pages/register/RegisterMain";
import DogBook from "./pages/dogbook/DogBookMain";
import Home from "./pages/Home";
import RegisterOwner from "./pages/register/RegisterOwner";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AddDog from "./pages/dogbook/AddDog";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import EditDog from "./pages/dogbook/EditDog";
import EditInfo from "./pages/dogbook/EditInfo";
import EditNotification from "./pages/dogbook/EditNotification";
import RegisterPetShop from "./pages/register/RegisterPetShop";
import RegisterSuccess from "./pages/register/RegisterSuccess";
import SpectraNearYouMain from "./pages/spectra-near-you/SpectraNearYouMain";
import SpectraNearYouList from "./pages/spectra-near-you/SpectraNearYouList";
import PetDaily from "./pages/petdaily/PetDiaryMain";
import PetDailyForm from "./pages/petdaily/PetDiaryForm";
import PetDailyView from "./pages/petdaily/PetDiaryView";
import SpectraNearYouCoupons from "./pages/spectra-near-you/SpectraNearYouCoupons";
import { useLiff } from "react-liff";
import { CircularProgress } from "@mui/joy";
import RegisterPetShopConfirm from './pages/register/RegisterPetShopConfirm';
import MyPointMain from './pages/my-point/MyPointMain';
import MyPointPhotoUpload from './pages/my-point/MyPointPhotoUpload';
import MemberCardOwnerMain from "./pages/member-card-owner/MemberCardOwnerMain"
import MemberCardOwnerEdit from "./pages/member-card-owner/MemberCardOwnerEdit"
import MemberCardOwnerEditEmployee from "./pages/member-card-owner/MemberCardOwnerEditEmployee"
import MyPointScan from './pages/my-point/MyPointScan';
import MyPointHistory from "./pages/my-point/MyPointHistory";
import RedeemGift from './pages/redeem-gift-shop/RedeemGiftMain';
import GenerateQRCodeMain from './pages/generate-qr-code/GenerateQRCodeMain';
import WelcomeBackPopup from "./components/popup/WelcomeBackPopup";
import RedeemGiftDetail from './pages/redeem-gift-shop/RedeemGiftDetail';
import QuestionnaireSuccess from './pages/questionnaire/QuestionnaireSuccess';
import QuestionnaireNotFound from './pages/questionnaire/QuestionnaireNotFound';
import RedeemGiftMember from './pages/redeem-gift-member/RedeemGiftMemberMain';
import RedeemGiftMemberDetail from './pages/redeem-gift-member/RedeemGiftMemberDetail';
import LoadingMain from './components/dialog/LoadingMain'
import CopyTag from './pages/i-frame/copy-tag';
import Game01 from './pages/auth-redirect/Game01';
import MyPointShop from "./pages/my-point-shop/MyPointShopMain";
import MyPointShopExport from "./pages/my-point-shop/MyPointShopExport";
import InviteFriend from "./pages/dogbook/InviteFriend";
import InviteFriendConfirm from "./pages/dogbook/InviteFriendConfirm";
import InviteFriendSuccess from "./pages/dogbook/InviteFriendSuccess";
import MyPointStamp from "./pages/my-point/MyPointStamp";
import QuizMania from "./pages/quiz-mania/QuizMania";
import QuizManiaRank from "./pages/quiz-mania/QuizManiaRank";
import CatBook from "./pages/catbook/CatBookMain";
import EditCat from "./pages/catbook/EditCat";
import EditInfoCat from "./pages/catbook/EditInfo";

import Game from './pages/game/gameIframe';
import RegisterMainCat from "./pages/register/RegisterMainCat";
import AddDogSuccess from "./pages/dogbook/AddDogSuccess";
import RegisterCatOwner from "./pages/register/RegisterCatOwner";
import PrivacyPolicyGreen from "./pages/PrivacyPolicyGreen";
import RegisterCatSuccess from "./pages/register/RegisterCatSuccess ";
import AddCat from "./pages/catbook/AddCat";
import ConfirmSuccess from "./pages/register/ConfirmSuccess";
import ConfirmCatSuccess from "./pages/register/ConfirmCatSuccess ";
import CatAddDogSuccess from "./pages/catbook/AddDogSuccess";
import CatAddCatSuccess from "./pages/catbook/AddCatSuccess ";
import EditDogCat from "./pages/catbook/EditDog";
import EditCatDog from "./pages/dogbook/EditCat";
import EditNotificationCat from "./pages/catbook/EditNotification";
import CatDailyForm from "./pages/petdaily-cat/PetDiaryForm";
import CatDiaryView from "./pages/petdaily-cat/PetDiaryView";
import CatDaily from "./pages/petdaily-cat/PetDiaryMain";
import DogAddCatSuccess from "./pages/dogbook/AddCatSuccess ";
import QrCodeSelect from "./pages/generate-qr-code/QrCodeSelect";
import MyPointMainCat from "./pages/my-point/MyPointMainCat";
import MyPointScanCat from "./pages/my-point/MyPointScanCat";
import MyPointHistoryCat from "./pages/my-point/MyPointHistoryCat";
import QuestionnaireSuccessCat from "./pages/questionnaire/QuestionnaireSuccessCat";
import QuestionnaireNotFoundCat from "./pages/questionnaire/QuestionnaireNotFoundCat";
import RedeemGiftMemberCat from "./pages/redeem-gift-member-cat/RedeemGiftMemberMainCat";
import RedeemGiftMemberDetailCat from "./pages/redeem-gift-member-cat/RedeemGiftMemberDetailCat";
import SpectraNearYouMainCat from "./pages/spectra-near-you-cat/SpectraNearYouMain";
import SpectraNearYouListCat from "./pages/spectra-near-you-cat/SpectraNearYouList";
import InviteFriendCat from "./pages/catbook/InviteFriendCat";
import InviteFriendConfirmCat from "./pages/catbook/InviteFriendConfirm";
import InviteFriendSuccessCat from "./pages/catbook/InviteFriendSuccess";
import SpectraNearYouCouponsCat from "./pages/spectra-near-you-cat/SpectraNearYouCoupons";
import AddNotification from "./pages/dogbook/AddNotification";
import NotificationMain from "./pages/dogbook/Notification";
import NotificationMainCat from "./pages/catbook/Notification";
import AddNotificationCat from "./pages/catbook/AddNotification";
import MyPointStampCat from "./pages/my-point/MyPointStampCat";



const theme = createTheme({
  typography: {
    fontFamily: `'DB Helvethaica X', 'Kanit', sans-serif`,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

function App() {
  const { isLoggedIn, liff } = useLiff();

  window.localStorage.removeItem('sub')
  if (isLoggedIn) {
    const sub = liff.getDecodedIDToken().sub;
    window.localStorage.setItem('sub', sub)
  }

  return (
    <>
      {isLoggedIn && (
        <ThemeProvider theme={theme}>
          <Layouts>
            <WelcomeBackPopup /> {/* ทำทุกหน้า */}
            <LoadingMain />
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="/register" element={<RegisterMain />} />
              <Route path="/register-cat" element={<RegisterMainCat />} />
              <Route path="/confirm-success" element={<ConfirmSuccess />} />
              <Route path="/confirm-success-cat" element={<ConfirmCatSuccess />} />
              <Route path="/dogbook" element={<DogBook />} />
              <Route path="/catbook" element={<CatBook />} />
              <Route path="/dogbook-invite-friend" element={<InviteFriend />} />
              <Route path="/dogbook-invite-friend-confrim" element={<InviteFriendConfirm />} />
              <Route path="/dogbook-invite-friend-success" element={<InviteFriendSuccess />} />
              <Route path="/catbook-invite-friend" element={<InviteFriendCat />} />
              <Route path="/catbook-invite-friend-confrim" element={<InviteFriendConfirmCat />} />
              <Route path="/catbook-invite-friend-success" element={<InviteFriendSuccessCat />} />
              <Route path="/dogbook-add" element={<AddDog />} />
              <Route path="/catbook-add" element={<AddCat />} />
              <Route path="/dogbook-edit/:petId" element={<EditDog />} />
              <Route path="/dogbook-edit-cat/:petId" element={<EditCatDog />} />
              <Route path="/dogbook-edit-noti" element={<EditNotification />} />
              <Route path="/dogbook-add-noti" element={<AddNotification/>} />
              <Route path="/dogbook-notification" element={<NotificationMain/>} />
              <Route path="/dogbook-edit-info" element={<EditInfo />} />
              <Route path="/dogbook-add-dog-success" element={<AddDogSuccess />} />
              <Route path="/dogbook-add-cat-success" element={<DogAddCatSuccess />} />
              <Route path="/catbook-edit/:petId" element={<EditCat />} />
              <Route path="/catbook-edit-dog/:petId" element={<EditDogCat />} />
              <Route path="/catbook-edit-info" element={<EditInfoCat />} />
              <Route path="/catbook-add-dog-success" element={<CatAddDogSuccess />} />
              <Route path="/catbook-add-cat-success" element={<CatAddCatSuccess />} />
              <Route path="/catbook-edit-noti" element={<EditNotificationCat />} />
              <Route path="/catbook-add-noti" element={<AddNotificationCat/>} />
              <Route path="/catbook-notification" element={<NotificationMainCat />} />
              <Route path="/register-owner" element={<RegisterOwner />} />
              <Route path="/register-cat-owner" element={<RegisterCatOwner />} />
              <Route path="/register-pet-shop" element={<RegisterPetShop />} />
              <Route path="/register-pet-shop-confirm" element={<RegisterPetShopConfirm />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy-cat" element={<PrivacyPolicyGreen />} />
              <Route path="/register-success" element={<RegisterSuccess />} />
              <Route path="/register-cat-success" element={<RegisterCatSuccess />} />
              <Route path="/pet-diary" element={<PetDaily />} />
              <Route path="/pet-diary-form" element={<PetDailyForm />} />
              <Route path="/pet-diary-view" element={<PetDailyView />} />
              <Route path="/cat-diary" element={<CatDaily />} />
              <Route path="/cat-diary-form" element={<CatDailyForm />} />
              <Route path="/cat-diary-view" element={<CatDiaryView />} />
              <Route path="/my-point" element={<MyPointMain />} />
              <Route path="/my-point-cat" element={<MyPointMainCat />} />
              <Route path="/my-point-scan" element={<MyPointScan />} />
              <Route path="/my-point-scan-cat" element={<MyPointScanCat />} />
              <Route path="/my-point-photo-upload" element={<MyPointPhotoUpload />} />
              <Route path="/my-point-history-owner" element={<MyPointHistory />} />
              <Route path="/my-point-history-cat-owner" element={<MyPointHistoryCat />} />
              <Route path="/my-point-stamp" element={<MyPointStamp />} />
              <Route path="/my-point-stamp-cat" element={<MyPointStampCat />} />
              <Route path="/generate-qr-code" element={<GenerateQRCodeMain />} />
              <Route path="/qr-code-select" element={<QrCodeSelect />} />
              <Route
                path="/spectra-near-you-main"
                element={<SpectraNearYouMain />}
              />
              <Route
                path="/spectra-near-you-list"
                element={<SpectraNearYouList />}
              />
              <Route
                path="/spectra-near-you-coupons"
                element={<SpectraNearYouCoupons />}
              />
              <Route
                path="/member-card-owner"
                element={<MemberCardOwnerMain />}
              />
              <Route
                path="/member-card-owner-edit"
                element={<MemberCardOwnerEdit />}
              />
              <Route
                path="/member-card-owner-edit-employee"
                element={<MemberCardOwnerEditEmployee />}
              />
              <Route path="/redeem-gift" element={<RedeemGift />} />
              <Route path="/redeem-gift-detail/:freebiesId/:clinicPetShopId" element={<RedeemGiftDetail />} />
              <Route path="/questionnaire-success" element={<QuestionnaireSuccess />} />
              <Route path="/questionnaire-success-cat" element={<QuestionnaireSuccessCat />} />
              <Route path="/questionnaire-not-found" element={<QuestionnaireNotFound />} />
              <Route path="/questionnaire-not-found-cat" element={<QuestionnaireNotFoundCat />} />
              <Route path="/redeem-gift-member" element={<RedeemGiftMember />} />
              <Route path="/redeem-gift-member-detail/:freebiesId/:memberId" element={<RedeemGiftMemberDetail />} />
              <Route path="/redeem-gift-member-cat" element={<RedeemGiftMemberCat />} />
              <Route path="/redeem-gift-member-detail/:freebiesId/:memberId" element={<RedeemGiftMemberDetail />} />
              <Route path="/redeem-gift-member-detail-cat/:freebiesId/:memberId" element={<RedeemGiftMemberDetailCat />} />
              <Route path="/iframe/copy-tag" element={<CopyTag />} />
              <Route path="/authgame" element={<Game01 />} />
              <Route path="/my-point-shop" element={<MyPointShop />} />
              <Route path="/my-point-export" element={<MyPointShopExport />} />

              {/* <Route path="/article-point" element={<ArticlePoint />} /> */}

              <Route path="/game-little-pet" element={<Game />} />

              <Route
                path="/spectra-near-you-main-cat"
                element={<SpectraNearYouMainCat />}
              />
              <Route
                path="/spectra-near-you-list-cat"
                element={<SpectraNearYouListCat />}
              />

              <Route
                path="/spectra-near-you-coupons-cat"
                element={<SpectraNearYouCouponsCat />}
              />
            </Routes>
          </Layouts>
        </ThemeProvider>
      )}
      {!isLoggedIn && (
        <div>
          <CircularProgress />
        </div>
      )}
    </>
  );
}

export default App;
